/* istanbul ignore file */
import React from 'react';

import { getInstanceDirectories, isDirectoriesAllowed } from '@lumapps/directories/ducks/selectors';
import type { SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { isInstanceSuperAdmin } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';

import { DirectoriesSideNavigation } from './DirectoriesSideNavigation';

const ConnectedDirectoriesSideNavigation: React.FC<Partial<SideNavigationItemProps>> = (props) => {
    const directories = useSelector(getInstanceDirectories);
    const isAllowed = useSelector(isDirectoriesAllowed);
    const isSuperAdmin = useSelector(isInstanceSuperAdmin);

    return (
        <DirectoriesSideNavigation
            {...props}
            directories={directories}
            isAllowed={isAllowed}
            isSuperAdmin={isSuperAdmin}
        />
    );
};

export { ConnectedDirectoriesSideNavigation as DirectoriesSideNavigation };
